export default "__VITE_ASSET___sp60IJC__"